module.exports = __webpack_public_path__ + "assets/img/23_90_big.285a017f.jpg";